const vertSlideEl = $('.js-vertical-slider');
const itemSelector = '.js-vertical-slider-item';
const vertSlideItemEls = $(itemSelector);
let vertSlideItems = [];
let currentIndex = 0;
const pauseTime = 3950;
let height;

if (vertSlideEl.length && vertSlideItemEls.length) {
    // Get array of text
    vertSlideItemEls.each(function(index, el) {
        vertSlideItems.push($(el).children('span').html());
    });

    // Remove initial items
    vertSlideItemEls.remove();

    // Get height for animaton later on
    setHeight();

    $(window).on('resize', function() {
        setHeight();
    });

    // Start the loop with first item
    prepareItem(vertSlideItems[currentIndex]);
}

function prepareItem(item) {
    // Show items first time else loop through them
    if (currentIndex < vertSlideItems.length) {
        // Create element and increment index for next slide
        vertSlideEl.append(createMarkup(item));
        currentIndex++;

        // Remove current class from other elements and add it to new element
        $(itemSelector).removeClass('current');
        var el = $(itemSelector + ':last-child');
        el.addClass('current');

        // Animate move of items
        $(itemSelector).each(function(subIndex, subEl) {
            $(subEl).css('margin-top', (parseFloat($(subEl).css('margin-top')) - height) + 'px');
        });
    } else {
        // Fade out main element and remove items
        vertSlideEl.addClass('fade-out');
        setTimeout(function() {
            vertSlideEl.removeClass('fade-out');
            $(itemSelector).remove();
        }, 500);
        
        // Reset index to start from beginning again next time
        currentIndex = 0;
    }

    // Do it all again
    setTimeout(function(){ 
        prepareItem(vertSlideItems[currentIndex]);
    }, pauseTime);
}

function createMarkup(text) {
    return  '<div class="c-vertical-slider__item  js-vertical-slider-item">' +
                '<span>' + text + '</span>' +
            '</div>';
}

function setHeight() {
    let width = $(window).width();
    height = 20;

    if (width > 768 && width < 1440) {
        height = 30;
    } else if (width >= 1440) {
        height = 60;
    }
}



// WEBPACK FOOTER //
// ./scripts/vert-slider.js